import axiosInstance from "../../../headersService";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";


export const createPublicAnnouncement = createAsyncThunk('createPublicAnnouncements', async (body, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL}/api/announcement/create-drive-announcement`, body)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const createPublicAnnouncementSlice = createSlice({
    name: 'Announcements',
    initialState: {
        loading: false,
        successMsg: null,
        error: null
    },
    reducers: {
        resetAnnouncementSuccessMsg: (state, action) => {
            state.successMsg = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(createPublicAnnouncement.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(createPublicAnnouncement.fulfilled, (state, action) => {
            state.loading = false;
            state.successMsg = action.payload.message
        })
        builder.addCase(createPublicAnnouncement.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to create announcement";
        })
    }
})

export const { resetAnnouncementSuccessMsg } = createPublicAnnouncementSlice.actions
export default createPublicAnnouncementSlice.reducer